module.exports = __webpack_public_path__ + "static/media/icon-sq-24-star-outline.b0c0e957.svg";